import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const { user } = useAuth();
  const [state, setState] = useState({ status: "processing" });
  const paypalOrderId = params.get("token");

  useEffect(() => {
    if (user === null || !paypalOrderId) return;
    if (user === false) { setState({ status: "failed", message: "Please log in to complete payment." }); return; }
    api.post("/payments/paypal/capture", { paypal_order_id: paypalOrderId })
      .then(({ data }) => setState({ status: "paid", reference: data.reference }))
      .catch((err) => setState({ status: "failed", message: formatApiErrorDetail(err.response?.data?.detail) }));
  }, [user, paypalOrderId]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-24 text-center" data-testid="payment-return-page">
      {state.status === "processing" && (
        <>
          <div className="font-display text-4xl text-white/50 mb-4">CONFIRMING YOUR PAYMENT…</div>
          <p className="text-white/40 text-sm">Hold tight — we're capturing your PayPal payment.</p>
        </>
      )}
      {state.status === "paid" && (
        <>
          <CheckCircle2 size={56} className="text-[#FFCC00] mx-auto mb-6" />
          <div className="font-display text-5xl mb-3">PAYMENT <span className="text-[#FFCC00]">COMPLETE.</span></div>
          <p className="text-white/50 text-sm mb-2">Order <span className="text-[#FFCC00]" data-testid="payment-return-reference">{state.reference}</span> is paid. Your stock is locked in.</p>
          <Link to="/account" data-testid="payment-return-account-link" className="btn-industrial inline-block px-8 py-3 text-lg mt-6">VIEW MY ORDERS</Link>
        </>
      )}
      {state.status === "failed" && (
        <>
          <XCircle size={56} className="text-[#FF3B30] mx-auto mb-6" />
          <div className="font-display text-5xl mb-3 text-[#FF3B30]">PAYMENT NOT COMPLETED.</div>
          <p className="text-white/50 text-sm">{state.message}</p>
          <p className="text-white/40 text-xs mt-2">Your order is still reserved — pay by bank transfer from your account page, or try again.</p>
          <Link to="/account" className="btn-ghost-industrial inline-block px-8 py-3 text-lg mt-6">GO TO MY ORDERS</Link>
        </>
      )}
    </div>
  );
}
